import { toast } from "react-toastify"
import { DynamicField, DynamicFieldTypes } from "src/components/dynamic-widget"
import DynamicFormWidget from "src/components/dynamic-widget/DynamicFormWidget"
import { isValidEmail } from "src/helpers/validation-utils"
import { DataService } from "src/services/data-service"
import { userRolesList } from "."
import { useState } from "react"
import { useNavigate } from "react-router"
import GenericDrawer from "src/components/drawer/GenericDrawer"
import { Password } from "@mui/icons-material"


interface IAddUserProps {
    onSuccess: () => void;
    onClose: () => void;
  }

const AddUser:  React.FC<IAddUserProps> = ({ onClose, onSuccess }) => {

    const navigate = useNavigate();
    const [formConfig, setFormConfig] = useState<Record<string, DynamicFieldTypes>>({
        username: {
            type: DynamicField.TEXT,
            required: true,
            name: "username",
            title: "User Name",
            value: "",
            disabled: false
        },
        Password: {
            type: DynamicField.TEXT,
            required: true,
            name: "password",
            title: "Password",
            value: "",
            disabled: false,
            inputType: "password"
        },
        role: {
            type: DynamicField.SELECT,
            required: true,
            name: "role",
            title: "Role",
            value: "",
            disabled: false,
            items: userRolesList
        }
    });

    const submit = async (data: Record<string, any>) => {
        const response = await DataService.post(
            "api/User/register",
            {...data, role: Number(data.role), country: "Lebanon"},
            undefined,
        );

        if (response.ok) {
            await onSuccess();
            return true;
        } else {
            const result: { message: string } = await response.json();
            toast.error(result.message || "An error occurred!");
            return false;
        }
    };


    return(
    <GenericDrawer title={'Add User'} open={true} onClose={onClose}>
      <DynamicFormWidget
      drawerMode
        title=""
        fields={formConfig}
        onSubmit={async (e) => {
        return await submit(e);
        }}
      />
      </GenericDrawer>
    );
}
export default AddUser;